import React from "react";
import styled from "styled-components";
import { StyledLabel, InputGroup, Error, Hint, StyledRequired } from "./styles";

export const StyledTextArea = styled.textarea`
    color: black;
    width: 100%;
    border: 1px solid #9a9c9f;
    border-radius: 6px;
    padding: 10px;
    font-weight: 400;
    font-size: 16px;
    :focus-visible {
        outline: none;
    }
    :disabled {
        border: ${(props) => (props.disabledWithBorder ? "default" : "none")};
        background-color: ${(props) => (props.disabledWithBorder ? "#80808024" : "transparent")};
        padding: ${(props) => (props.disabledWithBorder ? "10px" : "0px")};
        resize: none;
        font-size: 13px;
    }
`;
function TextArea({
    type,
    name,
    onChange,
    required,
    label,
    placeholder,
    error,
    isEditable,
    value,
    disabledWithBorder,
}) {
    return (
        <InputGroup>
            <StyledLabel>
                {label} {required && <StyledRequired>*</StyledRequired>}
            </StyledLabel>
            <StyledTextArea
                type={type}
                name={name}
                onChange={onChange}
                required={required}
                placeholder={placeholder}
                rows="4"
                disabled={!isEditable}
                value={value}
                disabledWithBorder={disabledWithBorder}
            />
            <Hint>{error && required && <Error>please fill this field </Error>}</Hint>
        </InputGroup>
    );
}

export default TextArea;
